import { Building2, Contact, FileText, FolderKanban, Handshake, LayoutDashboard, Users } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildSalesGroup(ctx: StaffNavContext): StaffNavGroup | null {
  // Staging and production keep client and contract links under Settings.
  // The Sales heading only appears when the CRM feature itself is on.
  if (!ctx.showSalesNav) return null

  const children: StaffNavNode[] = []

  if (ctx.showSalesNav) {
    children.push(
      leaf('sales_dashboard', 'Dashboard', AppPaths.salesDashboard, LayoutDashboard, [
        'pipeline',
        'follow up',
      ]),
      leaf('sales_prospects', 'Prospects', AppPaths.salesProspects, Contact, [
        'lead',
        'prospect',
        'pipeline',
      ]),
      leaf('sales_cases', 'Cases', AppPaths.salesCases, FolderKanban, [
        'case',
        'request',
        'inbox',
      ]),
      leaf('sales_accounts', 'Accounts', AppPaths.salesAccounts, Users, [
        'client',
        'account',
        'company',
      ]),
    )
  }

  if (ctx.showClientIdentityNav) {
    children.push(
      leaf('manage_clients', 'Manage Clients', AppPaths.adminClients, Building2, [
        'client',
        'company',
        'manage clients',
      ]),
    )
  }

  if (ctx.showAdminContracts) {
    children.push(
      leaf(
        'admin_contracts',
        'Contracts',
        AppPaths.adminContracts,
        FileText,
        ['client', 'commercial', 'contract', 'renewal'],
        { activeWhenPrefix: true },
      ),
    )
  }

  return group('sales', 'Sales', Handshake, ['sales', 'prospect', 'pipeline', 'clients'], children)
}
